import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircle from "@mui/icons-material/CheckCircle";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import RemoveCircleOutline from "@mui/icons-material/RemoveCircleOutline";

/**
 * @typedef {'pending'|'in_progress'|'complete'|'error'|'skipped'} ImportProgressStatus
 */

/**
 * @typedef {object} ImportProgressItem
 * @property {string} id
 * @property {string} label
 * @property {ImportProgressStatus} status
 */

/**
 * @param {object} props
 * @param {ImportProgressStatus} props.status
 */
const StatusIcon = ({ status }) => {
  if (status === "in_progress") {
    return <CircularProgress size={18} />;
  }
  if (status === "complete") {
    return <CheckCircle color="success" fontSize="small" />;
  }
  if (status === "error") {
    return <ErrorOutline color="error" fontSize="small" />;
  }
  if (status === "skipped") {
    return <RemoveCircleOutline color="disabled" fontSize="small" />;
  }

  return <RadioButtonUnchecked color="disabled" fontSize="small" />;
};

/**
 * @param {object} props
 * @param {ImportProgressItem[]} props.items
 */
export const ImportProgressList = ({ items }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <List dense disablePadding sx={{ minWidth: 260 }}>
      {items.map((item) => (
        <ListItem key={item.id} disableGutters sx={{ py: 0.25 }}>
          <ListItemIcon sx={{ minWidth: 28 }}>
            <StatusIcon status={item.status} />
          </ListItemIcon>
          <ListItemText primary={item.label} />
        </ListItem>
      ))}
    </List>
  );
};
